import { render, staticRenderFns } from "./DeveloperListApartmentCommercialModels.vue?vue&type=template&id=c9394070&"
import script from "./DeveloperListApartmentCommercialModels.vue?vue&type=script&lang=js&"
export * from "./DeveloperListApartmentCommercialModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports